module.exports = __webpack_public_path__ + "static/media/AcuminPro-Bold.20b4ed6a.svg";